export const getDetailRouteId = (mapLayer) => `${mapLayer.nameId}Detail`;
export const getListRouteId = (mapLayer) => `${mapLayer.nameId}List`;
export const getCreateRouteId = (mapLayer) => mapLayer.canInsert ? `${mapLayer.nameId}Create` : undefined;
export const getDetailQueryName = (mapLayer) => `query${mapLayer.nameId}Detail`;
//# sourceMappingURL=utils.js.map